/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TaskStatusesDto,
} from '../models/index';
import {
    TaskStatusesDtoFromJSON,
    TaskStatusesDtoToJSON,
} from '../models/index';

/**
 * 
 */
export class TaskStatusApi extends runtime.BaseAPI {

    /**
     * Get the status of the latest run of every background task, e.g. ruleset replacement, manual evaluation, bulk dunning level reset and dunning cron
     * Get statuses of background tasks
     */
    async getTaskStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskStatusesDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/status/tasks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskStatusesDtoFromJSON(jsonValue));
    }

    /**
     * Get the status of the latest run of every background task, e.g. ruleset replacement, manual evaluation, bulk dunning level reset and dunning cron
     * Get statuses of background tasks
     */
    async getTaskStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskStatusesDto> {
        const response = await this.getTaskStatusesRaw(initOverrides);
        return await response.value();
    }

}
